<template>
  <div class="container">
    <div class="top-bg">
      <!--<div class="return" @click="linkytowin">
        &lt;!&ndash; <img  src="../../static/images/return.png" alt /> &ndash;&gt;
       &lt;!&ndash; <img src="../../static/images/icon_logo.png" alt="">&ndash;&gt;
      </div>-->
      <img src="../../static/images/qie01.jpg" alt />
    </div>
    <div class="ct ct-centre">
      <shaixuan @getdata="getdata"></shaixuan>
      <div class="introduce">
        <div class="introduce-ct" v-if="teachersData_x!=''">
          <ul class="teachers" id="teachers">
            <li
              class="introduce-ct-li"
              v-for="(item,index) in teachersData_x"
              :key="index"
              @click="linktc(item)"
            >
              <img v-lazy="imgsrc+item.name+'.jpg'" alt />
              <div class="introduce-ct-text">
                <div class="text-c">
                  <i>{{item.name}}</i>
                  <span>{{item.grade2}} · {{item.sf}}</span>
                </div>
                <div class="text-x">
                  <span :title="item.tags">{{item.tags}}</span>
                  <p>{{item.tstag}}</p>
                </div>
                <div class="text-bt">
                  <p>学员数：{{item.num}}</p>
                  <p>好评率：{{item.percent}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="absence-data" v-else>
          <div class="absence-text">
            <img src="../../static/images/teacher-icon.png" alt />
            <p>暂无老师简介</p>
          </div>
        </div>
        <div class="block" v-if="teachersData_x!=''">
          <el-pagination
            @current-change="handleSizeChange"
            layout="prev, pager, next"
            :page-size="12"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <floatewm class="floatewm"></floatewm>
  </div>
</template>
<script>
import teacherData from "../../static/json/data.js";
import shaixuan from "../components/shaixuan";
import floatewm from "../components/floatewm";

export default {
  components: {
    shaixuan: shaixuan,
    floatewm: floatewm
  },
  mounted() {
    this.teachersData_x = this.teachersData.slice(0, 12);
    this.totalCount = this.teachersData.length;
  },
  data() {
    return {
      imgsrc: "./static/images/shrink-tc/",
      introducelistdata: {},
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      teachersData: [],
      teachersData_x: []
    };
  },
  methods: {
    getdata(data) {
      this.teachersData = data;
      this.teachersData_x = this.teachersData.slice(0, 12);
      this.totalCount = this.teachersData.length;
    },
    //页码
    handleSizeChange(val) {
      this.teachersData_x = this.teachersData.slice(
        (val - 1) * 12,
        (val - 1) * 12 + 12
      );
    },
    linktc(item) {
      this.linkdetils = item;
      localStorage.setItem("linkdetils", JSON.stringify(this.linkdetils));
      this.$router.push({
        path: "/details",
        query: {
          data: this.linkdetils
        }
      });
    },
     linkytowin() {
      window.location.href = "http://www.ytowin.com/";
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  .ct {
    width: 100%;
    margin: 20px auto;
  }
  .top-bg {
      .return {
      width: 1200px;
      margin: 0 auto;
      position: absolute;
      position: relative;
      span {
        cursor: pointer;
        left: 97%;
        top: -15px;
        padding: 95px 7px 5px 7px;
        color: #fff;
        text-align: center;
        width: 30px;
        height: 160px;
        position: absolute;
        background: url("../../static/images/return.png") no-repeat;
        background-size: 100%;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
      }
      span:hover {
        top: 0px;
      }
    }
    img {
      width: 100%;
      min-width: 1200px;
    }
  }
  .introduce {
    margin-top: 20px;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 200px;
    .introduce-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 44px;
      > h2 {
        width: 123px;
        height: 30px;
        font-size: 30px;
        font-weight: bold;
        color: #333333;
      }
      > a {
        width: 45px;
        height: 17px;
        font-size: 16px;
        color: #666666;
        opacity: 0.6;
      }
    }
    .introduce-ct {
      ul {
        width: 1200px;
        height: 100%;
        justify-content: space-between;
        .introduce-ct-li {
          cursor: pointer;
          margin-right: 18px;
          margin-bottom: 40px;
          cursor: pointer;
          float: left;
          width: 286px;
          height: 304px;
          > img {
            display: block;
            width: 286px;
            height: 166px;
            background-color: #52c65f;
            border-radius: 4px 4px 0px 0px;
          }
          .introduce-ct-text {
            box-sizing: border-box;
            padding: 16px 10px;
            width: 286px;
            height: 160px;
            background-color: #ffffff;
            box-shadow: 0px 1px 6px 0px rgba(18, 179, 117, 0.26);
            border-radius: 0px 0px 4px 4px;

            .text-c {
              > i {
                margin-right: 13px;
                font-style: normal;
                width: 54px;
                height: 18px;
                font-size: 18px;
                font-weight: normal;
                line-height: 24px;
                letter-spacing: 0px;
                color: #333333;
              }
              font-size: 14px;
              font-weight: normal;
              color: #999999;
            }
            .text-x {
              margin-top: 24px;
              font-size: 14px;
              letter-spacing: 0px;
              color: #333333;
            }
            .text-bt {
              display: flex;
              margin-top: 12px;

              p {
                margin-right: 32px;
                height: 12px;
                font-size: 12px;
                line-height: 30px;
                letter-spacing: 0px;
                color: #999999;
              }
            }
          }
        }
        .introduce-ct-li:nth-child(4n + 4) {
          margin-right: 0;
        }
      }
      ul::after {
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
      }
    }
    .absence-data {
      width: 100%;
      height: 300px;
      background: #eeeeee;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      .absence-text {
        text-align: center;
        > p {
          color: #aaaaaa;
          font-size: 20px;
        }
      }
    }
    .block {
      .el-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        /deep/ button {
          width: 24px;
          height: 24px;
          min-width: 0;
          border-radius: 4px;
          border: solid 1px #999999;
        }
        /deep/ button:hover {
          color: #fff;
          background-color: #5fb957;
          border-radius: 4px;
        }
        /deep/.btn-prev,
        /deep/.btn-next {
          margin: 0 5px;
          padding-left: 0;
          padding-right: 0;
        }

        /deep/.el-pager {
          height: 24px;
          .number {
            padding: 0;
            margin: 0 8px;
            width: 24px;
            height: 24px;
            border-radius: 4px;
            border: solid 1px #999999;
            line-height: 24px;
            min-width: 0;
          }
          .number:hover {
            color: #fff;
            background-color: #5fb957;
          }
          .active {
            background: #5fb957;
            color: #fff;
          }
          .btn-quicknext:hover {
            color: #5fb957;
          }
        }
      }
    }

    #tpages {
      .layui-box {
        margin: 0 auto;
        width: 380px;
        a {
          text-align: center;
          margin: 0 6px;
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          border: solid 1px #999999;
        }
        a:hover {
          color: #fff;
          width: 24px;
          height: 24px;
          background-color: #5bab52;
          border-radius: 4px;
        }
      }
    }
  }
  .floatewm {
    z-index: 99;
    position: fixed;
    right: 17px;
    top: 48%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/introducelist.vue